import { CommonModule } from '@angular/common';
import { Component, inject, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DropdownWithSectionsComponent } from '../../common/dropdown-with-sections/dropdown-with-sections.component';

@Component({
  selector: 'app-add-operation-modal',
  standalone: true,
  imports: [CommonModule, FormsModule, DropdownWithSectionsComponent],
  templateUrl: './add-operation-modal.component.html',
  styleUrl: './add-operation-modal.component.scss'
})
export class AddOperationModalComponent implements OnInit {

  activeModal = inject(NgbActiveModal);
  @Input() configs: any;
  isActive: boolean = false;

  data: any = {};
  url: any = 'https://api.example.com/v1/dummy/';
  requestValue: any;
  requestTypes: any = [
    {
      label: "",
      type: '',
      options: [
        {
          label: 'POST',
          icon: "assets/images/virtusa-icons/api/post.png",
          value: 'POST'
        },
        {
          label: 'GET',
          icon: "assets/images/virtusa-icons/api/get.png",
          value: 'GET'
        },
        {
          label: 'PUT',
          icon: "assets/images/virtusa-icons/api/put.png",
          value: 'PUT'
        },
        {
          label: 'PATCH',
          icon: "assets/images/virtusa-icons/api/patch.png",
          value: 'PATCH'
        },
        {
          label: 'DELETE',
          icon: "assets/images/virtusa-icons/api/delete.png",
          value: 'delete'
        }
      ]
    }
  ];
  dropdownConfig: any = {
    placeholderText: "Select request type",
    placeholderIcon: "",
    iconType: "assetImage",
  };


  ngOnInit(): void {
    this.url = this.configs?.url;
    if(this.configs?.isEdit){
      const dataUrl = this.configs.data.url;

      this.data = {...this.configs.data};
      this.requestValue = this.data.requestType;
      this.data.url = dataUrl.replace(this.url,'');
    }
  }

  onChange(event: any) {
    this.requestValue = event?.value;
  }

  save() {
    this.activeModal.close({
      ...this.data,
      type: this.requestValue,
      url: this.data.url,
      // url: this.url + this.data.url,
    });
  }
}
